export enum ViewControl {
    SafetyArea = "SafetyArea",
    GroundRiskBuffer = "GroundRiskBuffer",
    Path = "Path",
}

export enum MapLayer {
    Default = "default",
    SoraBoxes = "soraBoxes",
    Obstacles = "obstacles",
    VfrPoints = "vfrPoints",
    AirwaySegments = "airwaySegments",
    AirwaySegmentsConnections = "airwaySegmentsConnections",
}

export enum CqlFilterName {
    AerodromeTrafficCircuits = "aerodromeTrafficCircuits",
}
